import React from "react";
import "./about.css";
import aboutImage from "../../assets/about.jpg";
import { FaAward } from "react-icons/fa";
import { AiFillBulb } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";
const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <img src={aboutImage} alt="About" width="100%" height="100%" />
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Web Developement</h5>
              <small>2+ Years</small>
            </article>

            <article className="about__card">
              <AiFillBulb className="about__icon" />
              <h5>DSA</h5>
              <small>1000+ Problems</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
          </div>
          <p>
            I have been building websites since first year of college and made a
            lot of side projects. I have solved more than 1000 DSA problems
            covering almost all concepts of Data Structures & Algorithms across
            various coding platforms like{" "}
            <a
              href="https://leetcode.com/War_Codes/"
              target="_blank"
              rel="noreferrer"
            >
              Leetcode
            </a>
            ,{" "}
            <a
              href="https://www.codingninjas.com/studio/profile/war_codes"
              target="_blank"
              rel="noreferrer"
            >
              Coding Ninja
            </a>{" "}
            and{" "}
            <a
              href="https://www.hackerrank.com/war_codes"
              target="_blank"
              rel="noreferrer"
            >
              HackerRank
            </a>{" "}
            . I also love doing open source development, I actively maintain
            various open source projects on{" "}
            <a
              href="https://github.com/saransh79"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
            .
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
